import { Card, Table, Button } from "react-bootstrap";
import HamtdaaCheckModal from "../Modal/HamtdaaCheckModal";
import { useState, useEffect } from "react";

function UntMembers(props) {
  useEffect(() => {});
  if (
    !props.collective ||
    !props.collective.unitel ||
    props?.collective?.unitel?.members?.length === 0
  ) {
    return (
      <Card>
        <Card.Header className="d-flex justify-content-between align-items-center mb-3">
          <Card.Title as="h4" className="mb-0">
            Хамтдаа Гишүүд
          </Card.Title>
        </Card.Header>
        <Card.Body>Одоогоор Хамтдаад бүртгэлгүй байна</Card.Body>
      </Card>
    );
  }

  const groupId = props?.collective?.unitel?.groupId;
  return (
    <Card>
      <Card.Header className="d-flex justify-content-between align-items-center mb-3">
        <Card.Title as="h4" className="mb-0">
          Unitel Гишүүд
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Table
          className="table-hover table-striped"
          style={{
            fontSize: "12px",
          }}
        >
          <thead>
            <tr>
              <th className="border-0">Утасны дугаар</th>
              <th className="border-0">Group Id</th>
              <th className="border-0">Member Type</th>
              <th className="border-0">status</th>
            </tr>
          </thead>
          <tbody>
            {props?.collective?.unitel?.members?.map((member) => (
              <tr key={member.phoneNumber}>
                <td>{member.phoneNumber || ""}</td>
                <td>{groupId || ""}</td>
                <td>{member.role || ""}</td>
                <td>{member.status || ""}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}
export default UntMembers;
